import styled, { css } from "styled-components";

import { IArrowStyleProps, ISliderStyleProps } from "./interfaces";

export const Slider = styled.div<ISliderStyleProps>`
    transition: height 500ms;

    ${p =>
        p.isOverflowHidden
            ? css`
                  overflow: hidden;
              `
            : undefined}
`;

export const Arrow = styled.div<IArrowStyleProps>`
    float: right;
    .i-chevron-right {
        font-size: 30px;
        display: inline-block;
        margin-bottom: -6px;
        color: ${p => p.theme.c.dark};
        transform: rotate(90deg);
        transition: 400ms;
        font-weight: 600;
        ${p =>
            p.opened
                ? css`
                      transform: rotate(-90deg);
                  `
                : undefined}
    }
`;
